export default __webpack_public_path__ + "602c35bb50b18cf64988e9a4f914258b.png";